import InnerComponent from '@Components/Purchase/GoodsReceiving/GoodsReceivingHome/ViewGRN';
import orgContainer from '@Components/AppContainer';

const ViewGrnPage = () => ((orgContainer(InnerComponent)));
export default ViewGrnPage;
